import CancelModalButton from 'components/Custom/CancelModalButton'
import SubmitModalButton from 'components/Custom/SubmitModalButton'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import {
  addToJobOnboard,
  getSystemSetup,
  setAllJobApplicationsAndJobs,
  setFormSubmitted,
  updateOnboardingJob,
} from 'store/Recruitment/actions'
import CreateJobInput from '../../CreateJob/CreateJobInput'

const salaryDurations = [
  { name: 'Monthly', value: 'monthly' },
  { name: 'Weekly', value: 'weekly' },
]

const statusOptions = [
  { name: 'Pending', value: 'pending' },
  { name: 'Cancel', value: 'cancel' },
  { name: 'Confirm', value: 'confirm' },
]

function AddToJobOnboard({
  showModal,
  setShowModal,
  applicationId = null,
  interviewId = null,
  jobOnboard = null,
  onSuccessFn = () => {},
}) {
  const dispatch = useDispatch()
  const location = useLocation()

  const { currentSystemSetupRows: salaryTypes, allApplications } = useSelector(
    (store) => store.recruitment
  )

  const dontKnowApplication =
    location?.pathname === '/job-onboard' && !applicationId

  const [manualApplication, setManualApplication] = useState(null)

  const [joiningDate, setJoiningDate] = useState('')
  const [daysOfWeek, setDaysOfWeek] = useState(null)
  const [salary, setSalary] = useState(null)
  const [salaryType, setSalaryType] = useState(null)
  const [salaryDuration, setSalaryDuration] = useState(null)
  const [jobType, setJobType] = useState(null)
  const [status, setStatus] = useState(null)

  useEffect(() => {
    dispatch(getSystemSetup(null, 'salary_type'))
  }, [dispatch])

  useEffect(() => {
    if (dontKnowApplication) {
      dispatch(setAllJobApplicationsAndJobs())
    }
  }, [dontKnowApplication, dispatch])

  useEffect(() => {
    if (jobOnboard) {
      setJoiningDate(moment(jobOnboard?.joining_date).format('YYYY-MM-DD'))
      setDaysOfWeek(jobOnboard?.days_of_week)
      setSalary(jobOnboard?.salary)
      setSalaryType(
        salaryTypes?.find((el) => el?.id === jobOnboard?.salary_type)
      )
      setSalaryDuration(
        salaryDurations?.find((el) => el?.value === jobOnboard?.salary_duration)
      )
      setStatus(statusOptions?.find((el) => el?.value === jobOnboard?.status))
    }
  }, [jobOnboard, salaryTypes, salaryDuration])

  return (
    <Modal
      isOpen={showModal}
      toggle={() => setShowModal(false)}
      size='lg'
      centered
      scrollable
    >
      <ModalHeader className='border-bottom' toggle={() => setShowModal(false)}>
        {!jobOnboard ? 'Create' : 'Edit'} Job OnBoard
      </ModalHeader>
      <ModalBody className='scrollbar'>
        <form
          id='jobScreening'
          onSubmit={(e) => {
            e.preventDefault()

            dispatch(setFormSubmitted(true))

            const isValid = joiningDate && status && salaryType

            if (!isValid) {
              return
            }

            const payload = {
              // type: type?.option?.value,
              // branch: branch?.option?.id,
              application_id:
                manualApplication?.option?.id ??
                applicationId ??
                location?.search?.split('=')?.at(1),
              joining_date: joiningDate,
              days_of_week: daysOfWeek,
              salary,
              salary_type: salaryType?.option?.id,
              salary_duration: salaryDuration?.option?.value,
              job_type: jobType?.option?.value,
              status: status?.option?.value,
            }

            if (!jobOnboard) {
              dispatch(addToJobOnboard(payload))
            } else {
              dispatch(updateOnboardingJob(jobOnboard?.id, payload))
            }

            if (onSuccessFn) {
              onSuccessFn()
            }

            setShowModal(false)
          }}
        >
          <div className='d-flex flex-wrap w-100' style={{ gap: '0rem 1rem' }}>
            {dontKnowApplication && (
              <CreateJobInput
                id='jobApplication'
                label='Job Application'
                placeholder='Select Application'
                required={true}
                fullSize={true}
                select={true}
                options={allApplications}
                selectedOptions={manualApplication}
                onChange={(val) => setManualApplication(val)}
              />
            )}
            {/* <CreateJobInput
              id='type'
              placeholder='Select Type'
              label='Type'
              required={true}
              fullSize={false}
              select={true}
              options={recruitmentTypeOptions}
              onChange={(val) => setType(val)}
              selectedOptions={type}
            />
            <CreateJobInput
              id='branch'
              placeholder='Select Branch'
              label='Branch'
              required={true}
              fullSize={false}
              select={true}
              options={allStores}
              onChange={(val) => setBranch(val)}
              selectedOptions={branch}
            /> */}
            <CreateJobInput
              id='joiningDate'
              label='Joining Date'
              required={true}
              fullSize={false}
              type='date'
              defaultValue={joiningDate}
              onChange={(val) => setJoiningDate(val)}
            />
            <CreateJobInput
              id='daysOfWeek'
              placeholder='Enter Days Of Week'
              label='Days Of Week'
              fullSize={false}
              type='number'
              defaultValue={daysOfWeek}
              onChange={(val) => setDaysOfWeek(val)}
            />
            <CreateJobInput
              id='salary'
              placeholder='Enter Salary'
              label='Salary'
              type='number'
              fullSize={false}
              defaultValue={salary}
              onChange={(val) => setSalary(val)}
            />
            <CreateJobInput
              id='salaryType'
              placeholder='Select Salary Type'
              label='Salary Type'
              fullSize={false}
              select={true}
              required={true}
              options={salaryTypes}
              onChange={(val) => setSalaryType(val)}
              selectedOptions={salaryType}
            />

            <CreateJobInput
              id='salaryDuration'
              placeholder='Select Salary Duration'
              label='Salary Duration'
              fullSize={false}
              select={true}
              options={salaryDurations}
              onChange={(val) => setSalaryDuration(val)}
              selectedOptions={salaryDuration}
            />
            {/* <CreateJobInput
              id='jobType'
              placeholder='Select Job Type'
              label='Job Type'
              fullSize={false}
              select={true}
              options={jobTypeOptions}
              onChange={(val) => setJobType(val)}
              selectedOptions={jobType}
            /> */}
            <CreateJobInput
              id='status'
              placeholder='Select Status'
              label='Status'
              fullSize={false}
              select={true}
              options={statusOptions}
              required={true}
              onChange={(val) => setStatus(val)}
              selectedOptions={status}
            />
          </div>
        </form>
      </ModalBody>
      <ModalFooter>
        <CancelModalButton
          customFn={() => setShowModal(false)}
        ></CancelModalButton>
        <SubmitModalButton
          text={!jobOnboard ? 'Create' : 'Update'}
          form='jobScreening'
        ></SubmitModalButton>
      </ModalFooter>
    </Modal>
  )
}

export default AddToJobOnboard
